export default {
	namespaced: true,

	state:      {
		popupRes: {},
	},

	getters: {
		popupRes: state => state.popupRes,
	},

	mutations: {
		setPopupRes(state, payload) {
			state.popupRes = payload;
		}
	}
};
